import React from 'react';
import { Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import { InventoryBreakdownComponent, IWarehouseMapping } from '../themes/gardner-theme/views/components/inventory-breakdown.component';
import { RichTextComponent } from '@msdyn365-commerce/core';
import { SimpleProductExt } from '../modules/eve-quick-order/eve-quick-order';
import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';

interface AvailabilityModalProps {
    isOpen: boolean;
    toggle: () => void;
    modalProduct: SimpleProductExt | ProductSearchResult | undefined;
    config: InventoryAvailabilityConfig;
}

export interface InventoryAvailabilityConfig {
    warehouseAvailabilityReadOnlyMessage: string;
    allowableFreightWarehouseLabel: string;
    designatedDealerTypes: string;
    productCodeWhitelist: string;
    preferredWarehouseLabel: string;
    alternateWarehouseMappings: IWarehouseMapping[];
    pdpWarehouseSelectionNote: string;
    authorizedWarehouseAccounts: string[];
    isAlternateWarehouseFeatureEnabled: boolean;
    allowedDealerTypes: string;
    designatedCustomerGroups: string;
    enableAlternateWarehouseFeature: boolean;
}

const InventoryAvailabilityModal: React.FC<AvailabilityModalProps> = ({ isOpen, toggle, modalProduct, config }) => {
    return (
        <Modal className='alternate-warehouse__modal_content' isOpen={isOpen} toggle={toggle}>
            <ModalHeader className='alternate-warehouse__modal__header' toggle={toggle}>
                Warehouse Availability
            </ModalHeader>
            <ModalBody className='alternate-warehouse__modal__body'>
                <RichTextComponent text={config.warehouseAvailabilityReadOnlyMessage} />
                <p className='item-info top-margin'>
                    <strong>Item:</strong> {modalProduct?.ItemId!}
                </p>

                <InventoryBreakdownComponent
                    extensionProperties={modalProduct?.ExtensionProperties}
                    itemId={modalProduct?.ItemId!}
                    canBackorder={true}
                    allowableText={config.allowableFreightWarehouseLabel}
                    designatedDealerTypes={config.designatedDealerTypes}
                    productCodeWhitelist={config.productCodeWhitelist}
                    alternateText={config.preferredWarehouseLabel}
                    warehouseMappings={config.alternateWarehouseMappings}
                />

                <p className='note'>
                    <RichTextComponent text={config.pdpWarehouseSelectionNote} />
                </p>
            </ModalBody>
        </Modal>
    );
};

export default InventoryAvailabilityModal;
